import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=ffb3637e&"
import script from "./Overview.vue?vue&type=script&lang=js&"
export * from "./Overview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/builds/rentmagic/rentmagic.website.vue.west-vlaanderen/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCard, BTable, BCol, BRow} from 'bootstrap-vue'
    installComponents(component, {BCard, BTable, BCol, BRow})
    

export default component.exports